import React from "react";
import PropTypes from "prop-types";
import { Link } from "@quintype/components";
import { HeroImage } from "../../../atoms/HeroImage";
import { PublishAndReadTime } from "../../../atoms/PublishAndReadTime";
import CardInfo from "./CardInfo";
import { isExternalStory } from "../../../utils/story";

import "./story-card.m.css";

const StoryCard = ({
  story,
  showTimeStamp,
  showReadTime,
  showSubHeadline = false,
  isHorizontal = false,
  isHeroStory = false,
  sectionSlug,
}) => {
  const externalStoryUrl = isExternalStory(story);
  const href = externalStoryUrl ? externalStoryUrl : `/${story?.slug}`;
  const target = externalStoryUrl ? "_blank" : "_self";
  return isHorizontal ? (
    <Link href={href} target={target}>
      <div styleName="horizontal-card">
        <div>
          <HeroImage story={story} aspectRatio={[[4, 3]]} iconSizes={{ height: 24, width: 24 }} />
        </div>
        <div styleName="info">
          <CardInfo
            story={story}
            isHeroStory={isHeroStory}
            showSubHeadline={showSubHeadline}
            sectionSlug={sectionSlug}
          />
          <PublishAndReadTime story={story} showReadTime={showReadTime} showTimestamp={showTimeStamp} />
        </div>
      </div>
    </Link>
  ) : (
    <Link href={href} target={target}>
      <div styleName="card">
        <HeroImage story={story} aspectRatio={[[4, 3]]} iconSizes={{ height: 24, width: 24 }} />
        <CardInfo story={story} isHeroStory={isHeroStory} showSubHeadline={showSubHeadline} sectionSlug={sectionSlug} />
        <PublishAndReadTime story={story} showReadTime={showReadTime} showTimestamp={showTimeStamp} />
      </div>
    </Link>
  );
};

StoryCard.propTypes = {
  story: PropTypes.shape({
    slug: PropTypes.string,
    subheadline: PropTypes.string,
  }),
  showTimeStamp: PropTypes.bool,
  showReadTime: PropTypes.bool,
  showSubHeadline: PropTypes.bool,
  isHorizontal: PropTypes.bool,
  isHeroStory: PropTypes.bool,
  sectionSlug: PropTypes.string,
};

export default StoryCard;
